import { css, styled } from 'styles';

const baseStyles = css`
  color: inherit;
  display: block;
  font-family: inherit;
  font-weight: 600;
  line-height: 1.2em;
  margin: ${({ theme }) => theme.spacing.relative.medium} 0
    ${({ theme }) => theme.spacing.relative.small};
  padding: 0;

  &:first-child {
    margin-top: 0;
  }
`;

export const StyledHeading1 = styled.h1`
  ${baseStyles};
  font-size: 2.25rem;
`;

export const StyledHeading2 = styled.h2`
  ${baseStyles};
  font-size: 2rem;
`;

export const StyledHeading3 = styled.h3`
  ${baseStyles};
  font-size: 1.75rem;
`;

export const StyledHeading4 = styled.h4`
  ${baseStyles};
  font-size: 1.5rem;
`;

export const StyledHeading5 = styled.h5`
  ${baseStyles};
  font-size: 1.3rem;
`;

export const StyledHeading6 = styled.h6`
  ${baseStyles};
  font-size: 1.1rem;
`;

StyledHeading1.displayName = 'Heading1.Styled';
StyledHeading2.displayName = 'Heading2.Styled';
StyledHeading3.displayName = 'Heading3.Styled';
StyledHeading4.displayName = 'Heading4.Styled';
StyledHeading5.displayName = 'Heading5.Styled';
StyledHeading6.displayName = 'Heading6.Styled';
